import { useSelector } from 'react-redux';
import { RootState } from 'store';
import GenerateBrandBookForm from '../components/GenerateBrandBookForm';
import BrandBooksReference from '../components/BrandBooksReference';
import Questions from 'features/bot-builder/components/Common/Questions';
import { Apps } from 'constants/global';

const GetStartedPage = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div>
      <main className="overflow-auto bg-background-main feature-gradient-bg h-fit">
        <section className="text-text-primary grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-24 p-4 lg:p-12 max-w-[1260px] mx-auto">
          <div className="flex flex-col gap-4">
            <img
              src={isDarkMode ? '/brandbook-dark.svg' : '/brandbook.svg'}
              alt="BrandBook Hero"
              className="max-h-[120px] md:max-h-[146px] h-full w-fit"
            />
            <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px]">
              Welcome to <br />
              BrandBook
            </h1>
            <p className="text-sm lg:text-xl font-medium text-text-primary md:w-[400px] mb-6 lg:mb-0">
              Create a professional, cohesive brandbook in mintues. From logos
              and typography to color palettes, values and vision, our generator
              helps you bring it all together effortlessly.
            </p>
          </div>

          <div className="lg:col-span-2">
            <GenerateBrandBookForm />
          </div>
        </section>
      </main>

      <section className="p-4 lg:p-12 bg-background text-text-primary">
        <BrandBooksReference />
      </section>

      <Questions appType={Apps.BRANDBOOK} />
    </div>
  );
};

export default GetStartedPage;
